/** App URLs used from the marketing site so signup stays seamless. */
export const APP_PRICING_URL = "https://app.propertyvue.io/pricing";
export const APP_SIGN_IN_URL = "https://app.propertyvue.io/auth/login";
